__turbopack_context__.v({
  "agreement_block": "_4bGXxa_agreement_block",
  "content_box": "_4bGXxa_content_box",
  "icon_btn": "_4bGXxa_icon_btn",
});
